import { Outlet } from "react-router";
import Footer from "../components/ui/footer";
import Header from "../components/ui/header";
// import './css/global.css'
import { Stack } from "@mui/material";

export default function HomeAppLayout() {
    return (
        <body className={`font-inter antialiased text-gray-200 tracking-tight`}
            style={{
                background: 'rgb(25, 62, 106)',
                background: ' radial-gradient(circle at center top, rgba(25, 62, 106, 1) 0%, rgba(0, 0, 0, 1) 20%)'
            }}>
            <div className="flex flex-col min-h-screen overflow-hidden">
                <Header />
                <Outlet />
            </div>
        </body>
    )
}